import React, { useState, useEffect } from 'react'
import { proc_qry_billCols,proc_prev_billCols } from '../../../constants/procBillConstants'
import { FGLOBAL } from '../../../constants/frontGlobal'
import { Tooltip, Table, Button, ConfigProvider, Modal, Input } from 'antd';
import './bill-mgt.less'
import { RollbackOutlined, SearchOutlined } from '@ant-design/icons';
import zhCN from 'antd/es/locale/zh_CN';
import { useSelector } from 'react-redux'
import { queryAxios, mask, unmask } from '../../../components/reqAndHint'

/**
 * 
 * @param {*} props 
 * 待处理列表查看明细弹窗页
 */
export default function QueryBill(props) {
    const [dataSource, setDataSource] = useState([]);
    const langValue = useSelector(state=>state.langList.value)
    const columns = proc_prev_billCols.map(item=>{
        return {
            title: item.title,
            en_title: item.en_title,
            ch_title: item.ch_title,
            dataIndex: item.dataIndex,
        }
    });
    const { Search } = Input;
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [rawData, setRawData] = useState();

    if (FGLOBAL.get('roleId') && +FGLOBAL.get('roleId') < 4) {
        //地区财务窗口以外人员 表头额外字段
        columns.push({
            title: '项目备注',
            en_title: 'Project Notes',
            ch_title: '项目备注',
            dataIndex: '项目备注',
            sorter: (a, b) => {
                if (a['项目备注']) {
                    return a['项目备注'].localeCompare(b['项目备注'])
                }
            }
        });
    }

    const handleSearch = (value) => {
        //有rawDate则说明是多次搜索
        if (rawData) {
            //有搜索关键词且当前数据和原数据相同，正常过滤
            if (rawData == dataSource && value) {
                // console.log('多次search');
                setRawData(dataSource);
                mask();
                let newData = dataSource.filter(d => d['开立票据名称'].includes(value));
                // console.log('after filter:', newData);
                setDataSource(newData);
                unmask();
                //无关键词，且过滤后和原数据不同，返回原数据
            } else {
                // console.log('多次取消search');
                setDataSource(rawData);
            }

            //没有rowData,说明是第一次搜索
        } else {
            //有关键词，则正常过滤筛选
            if (value) {
                // console.log('第一次search');
                setRawData(dataSource);
                mask();
                let newData = dataSource.filter(d => d['开立票据名称'].includes(value));
                // console.log('after filter:', newData);
                setDataSource(newData);
                unmask();
                //没有值，无反应
            } else {
                // console.log('第一次取消search');
            }
        }
    }
    let showSearchstr
    if(langValue==0){
        showSearchstr = showSearchBar ? '点击收起搜索Click to collapse search' : '点击展开搜索Click to expand search'
    }
    else if(langValue==1){
        showSearchstr = showSearchBar ? '点击收起搜索' : '点击展开搜索'
    }else {
        showSearchstr = showSearchBar ? 'Click to collapse search' : 'Click to expand search'
    }
    columns[1].title =
        <div id='procq-scth'>
            <span>{langValue==0?'开立票据名称Receipt Title':(langValue==1?'开立票据名称':'Receipt Title')}</span>

            <span>
                <Tooltip title={showSearchstr}>
                    <SearchOutlined
                        onClick={() => {
                            let s = showSearchBar
                            setShowSearchBar(!showSearchBar);
                        }}
                        style={{ fontSize: '20px', fontWeight: '1000', border: '1px solid blue', color: 'blue', position: 'relative', left: '5px', top: '2px' }} />
                </Tooltip >
            </span>
            <Search
                placeholder={langValue==0?'输入关键字Enter Keyword':(langValue==1?'输入关键字':'Enter Keyword')}
                allowClear
                enterButton
                onSearch={handleSearch}
                style={{ display: showSearchBar ? 'block' : 'none' }}
            />
        </div>
    const [pageSize, setPageSize] = useState(10);

    useEffect(async () => {
        // console.log('recordId:', props.recordId);
        let data = await queryAxios('/bill/getBillRecordSubById', { recordId: props.recordId });
        if (data) {
            try {
                // console.log('查看票据明细data:', data.data.data);
                let dtSrc = [...data.data.data.bill_detail];
                dtSrc.forEach((d, i) => d['序号'] = i + 1);
                setDataSource(dtSrc.splice(0));
            } catch (e) {
                Modal.error({ content: '查看票据明细错误：' + e });
            }
        }
    }, [])
    const getColumns = (col) => {
        let newCol = [...col];
        newCol.forEach((item,i)=>{
            if(item.dataIndex=='Email')return
            if(item.dataIndex!='开立票据名称'){
                item.title = langValue==0?<>{item.ch_title}<br/>{item.en_title}</>:(langValue==1?item.ch_title:item.en_title)
            }
        })
        return newCol
    }

    return (
        <div className="bill-mgt">
            <div className="base-info">
                <div className='bill-mgt-nav'>
                    <span className='content'>{langValue==0?"待处理列表 Pending list":(langValue==1?"待处理列表":'Pending list')}{'>'}{langValue==0?'查看View':(langValue==1?'查看':'View')}</span>
                    <Button className='back-button' type='link'
                        onClick={() => { props.setModalVisible(false) }}>
                        <RollbackOutlined style={{ fontSize: '16px', fontWeight: '1900', color: '#08c' }} />
                        {langValue==0?'返回Return':(langValue==1?'返回':'Return')}
                    </Button>
                </div>
                <h1 className="info-title">
                {langValue==0?'基础信息 Basic Information':(langValue==1?'基础信息':'Basic Information')}
                </h1>
                <div className='bi-content'>
                    <div className='bc-item'>
                        <span>{langValue==0?'录入日期(Date of Entry )':(langValue==1?'录入日期':'Date of Entry ')}：</span>
                        <span>{props.recordDate}</span>
                    </div>
                    <div className='bc-item'>
                        <span>{langValue==0?'地区(Region)':(langValue==1?'地区':'Region')}：</span>
                        <span>{props.recordArea}</span>
                    </div>
                    <div className='bc-item'>
                        <span>{langValue==0?'志工人数Number of Volunteers':(langValue==1?'志工人数':'Number of Volunteers')}：</span>
                        <span>{props.recordVolCnt}</span>
                    </div>
                </div>
            </div>
            <div className="bill-info">
                <div className="info-title">
                    <span>{langValue==0?'票据信息 Ticket Information':(langValue==1?'票据信息':'Ticket Information')}</span>
                </div>
                <div className='proc-query-table-container'>
                    <ConfigProvider locale={zhCN}>
                        <Table
                            sticky
                            rowKey="序号"//editableKeys
                            scroll={{
                                x: 960,
                            }}

                            columns={getColumns(columns)}
                            dataSource={dataSource}

                            pagination={{
                                pageSize: pageSize,
                                pageSizeOptions: [10, 20, 50, 100, 1000],
                                showQuickJumper: true,
                                showSizeChanger: true,//可选每页条数，数据少时仍展示
                                onChange: (page, pageSize) => setPageSize(pageSize),
                            }}
                            bordered
                        />
                    </ConfigProvider>
                    <Button className='back-button-bottom' type='link' style={{ position: 'absolute', right: '20px', fontWeight: '600', fontSize: '16px' }}
                        onClick={() => { props.setModalVisible(false) }}>
                        <RollbackOutlined style={{ fontSize: '16px', fontWeight: '1900', color: '#08c' }} />
                        {langValue==0?'返回Return':(langValue==1?'返回':'Return')}
                    </Button>
                </div>
            </div>
        </div>
    )
}
